import { useParams } from "react-router-dom";
import Button from "components/button";
import Input from "components/input";
import ConfirmationModal from "components/shared/confirmation-modal";
import useEditVehicleAuxiliaryForm from "./useEditVehicleAuxiliaryForm";

// export const editVehicleAuxiliaryPageRouteName =
//   "/master-data/vehicle-auxiliary/:id/edit";

export const editVehicleAuxiliaryPageRouteName = (id?: string) => 
`/master-data/vehicle-auxiliary/${id ?? ":id"}/edit`;

const EditVehicleAuxiliaryPage = () => {
  const { id } = useParams<{ id: string }>();
  const {
    handleSubmit,
    errors,
    register,
    showSaveModal,
    setShowSaveModal,
    showCancelModal,
    setShowCancelModal,
    onSubmit,
    handleConfirmSave,
    handleConfirmCancel,
    t,
  } = useEditVehicleAuxiliaryForm(id);

  return (
    <div className="flex flex-col gap-6">
      <section className="rounded-2xl border border-border bg-white p-6 shadow-sm">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex flex-col gap-4"
        >
          <Input
            label={t("label-auxiliary-name")}
            placeholder={t("label-auxiliary-name")}
            required
            {...register("auxiliaryName")}
            error={errors.auxiliaryName}
            data-testid="input-auxiliary-name-edit"
          />
        </form>
      </section>

      {/* Bottom Action Bar */}
      <div className="flex justify-end gap-3">
        <Button
          type="button"
          variant="outline"
          color="tertiary"
          size="medium"
          onClick={() => setShowCancelModal(true)}
          data-testid="btn-cancel-auxiliary-edit"
        >
          {t("btn-cancel")}
        </Button>
        <Button
          type="button"
          variant="fill"
          color="primary"
          size="medium"
          onClick={handleSubmit(onSubmit)}
          data-testid="btn-save-auxiliary-edit"
        >
          {t("btn-save")}
        </Button>
      </div>

      {/* Save Confirmation Modal */}
      <ConfirmationModal
        open={showSaveModal}
        title={t("modal-save-title")}
        message={t("modal-save-message")}
        confirmLabel={t("modal-confirm-save")}
        cancelLabel={t("modal-confirm-cancel")}
        onConfirm={handleConfirmSave}
        onCancel={() => setShowSaveModal(false)}
        testId="save-auxiliary-edit-modal"
      />

      {/* Discard Confirmation Modal */}
      <ConfirmationModal
        open={showCancelModal}
        title={t("modal-discard-title")}
        message={t("modal-discard-message")}
        confirmLabel={t("modal-confirm-discard")}
        cancelLabel={t("modal-confirm-stay")}
        onConfirm={handleConfirmCancel}
        onCancel={() => setShowCancelModal(false)}
        testId="discard-auxiliary-edit-modal"
      />
    </div>
  );
};

export default EditVehicleAuxiliaryPage;
